module.exports = __webpack_public_path__ + "img/video-call.094283c8.svg";